/**
 * Services for pushing events to the GTM data layer (GA4/GTM).
 * Use for tracking user activities. Call from pages/components as needed.
 */

import { logEventToAppInsights } from './appInsightsLoggingService'

export const DATA_LAYER_EVENTS = {
  ORDER_FLOW: 'order_flow',
  INTERACTION: 'interaction',
} as const

function ensureDataLayer(): void {
  if (typeof window === 'undefined') return
  ;(window as any).dataLayer = (window as any).dataLayer || []
}

export function pushEventToDatalayer(eventName: string, payload?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  ensureDataLayer()
  try {
    ;(window as any).dataLayer.push({ event: eventName, ...payload })
  } catch (e) {
    console.error('DataLayer push failed:', e)
  }
  logEventToAppInsights(eventName, payload)
}

export function pushOrderFlowToDatalayer(
  step: number,
  stepName: string,
  params?: Record<string, unknown>,
): void {
  pushEventToDatalayer(DATA_LAYER_EVENTS.ORDER_FLOW, { step, step_name: stepName, ...params })
}

export function pushInteractionToDatalayer(action: string, payload: Record<string, unknown>): void {
  pushEventToDatalayer(DATA_LAYER_EVENTS.INTERACTION, {
    action,
    ...payload,
    selection: payload?.selection ?? '',
  })
}
